import BaseModelInstance from './base.model'
import { UserContractCartMeta as ModelDefinition } from './model-definitions'

class UserContractCartMeta extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserContractCartMeta
